<script setup lang="ts">
import { ECH_STATUS } from '@/models/Status';
import { computed } from 'vue';

const props = defineProps<{
    status: string;
    text: string;
}>();
const statusAppearanceMap = {
    [ECH_STATUS.STATUS_NEW]: 'highlight',
    [ECH_STATUS.WAITING_FOR_SIGNATURE]: 'highlight', // eigener status
    [ECH_STATUS.SUBMITTED]: 'running',
    [ECH_STATUS.IN_PROGRESS]: 'running',
    [ECH_STATUS.SUSPENDED]: 'running',
    [ECH_STATUS.APPELLANT_PROCESS]: 'running',
    [ECH_STATUS.OBJECTION_PENDING]: 'running',
    [ECH_STATUS.DECISION_ISSUED]: 'success',
    [ECH_STATUS.DECISION_LEGALLY_BINDING]: 'success',
    [ECH_STATUS.UNDER_CONSTRUCTION]: 'success',
    [ECH_STATUS.DEMAND_DOCUMENTS]: 'highlight',
    [ECH_STATUS.DEMAND_DOCUMENTS_GEMEINDE]: 'running',
    [ECH_STATUS.WITHDRAWN]: 'idle',
    [ECH_STATUS.BUILDING_FREEZE]: 'error',
    // missing status: positive_bewilligt (success)
    // missing status: positive_with_conditions / bewilligt mit vorbehalt (success)
    // missing status: building_clearance (success)
    // missing status: non-approval of introduction / Nicht eintreten? (idle)
    [ECH_STATUS.DOSSIER_CLOSED]: 'warning',
    [ECH_STATUS.DOSSIER_ARCHIVED]: 'warning'
    // missing status: rejected / abgelehnt (danger)
};
const appearance = computed(() => {
    return statusAppearanceMap[props.status] ?? 'idle';
});
</script>

<template>
    <ktg-pill :appearance="appearance">{{ props.text }}</ktg-pill>
</template>
